import PropTypes from 'prop-types'
import { ObjectTextMessageDirections } from '../../models/vehicle/object-text-message-directions-enum'

/**
 * This is the ObjectTextMessageStatus type definition for the REST model.
 *
 * @typedef {string} ObjectTextMessageDirection
 */
export const objectTextMessageDirectionPropType = PropTypes.oneOf(Object.values(ObjectTextMessageDirections))
